(() => {

  function initializeEditorialMarquee(section) {

    if (
      !section ||
      section.dataset.initialized === 'true'
    ) {
      return;
    }


    section.dataset.initialized =
      'true';



    /* =====================================================
       ELEMENTS
    ===================================================== */

    const viewport =
      section.querySelector(
        '[data-editorial-viewport]'
      );


    const track =
      section.querySelector(
        '[data-editorial-track]'
      );


    const firstGroup =
      section.querySelector(
        '[data-editorial-group]'
      );


    const slots =
      Array.from(
        section.querySelectorAll(
          '[data-editorial-card-slot]'
        )
      );


    const autoplayButton =
      section.querySelector(
        '[data-editorial-autoplay]'
      );


    const playIcon =
      section.querySelector(
        '[data-play-icon]'
      );


    const pauseIcon =
      section.querySelector(
        '[data-pause-icon]'
      );


    const autoplayText =
      section.querySelector(
        '[data-autoplay-text]'
      );


    const previousButton =
      section.querySelector(
        '[data-editorial-previous]'
      );


    const nextButton =
      section.querySelector(
        '[data-editorial-next]'
      );


    const customCursor =
      section.querySelector(
        '[data-custom-cursor]'
      );


    const cardLinks =
      section.querySelectorAll(
        '[data-editorial-card-link]'
      );


    if (
      !viewport ||
      !track ||
      !firstGroup ||
      !slots.length
    ) {
      return;
    }



    /* =====================================================
       SETTINGS
    ===================================================== */

    let autoplayEnabled =
      section.dataset.autoplay ===
      'true';


    let temporarilyPaused =
      false;


    let animationFrame =
      null;


    let lastTimestamp =
      null;


    let position =
      0;


    const speed =
      Math.max(
        5,
        Number(
          section.dataset.speed
        ) ||
        30
      );


    const direction =
      section.dataset.direction ===
      'right'
        ? 1
        : -1;


    const pauseOnHover =
      section.dataset.pauseHover ===
      'true';


    const edgeEffectEnabled =
      section.dataset.edgeEffect !==
      'false';


    const mobileEdgeEffectEnabled =
      section.dataset.mobileEdgeEffect ===
      'true';


    const edgeZone =
      Math.max(
        60,
        Number(
          section.dataset.edgeZone
        ) ||
        260
      );


    const minimumScale =
      Math.min(
        1,
        Math.max(
          0.01,
          Number(
            section.dataset.edgeScale
          ) ||
          0.24
        )
      );



    /* =====================================================
       HELPERS
    ===================================================== */

    function clamp(
      value,
      minimum,
      maximum
    ) {

      return Math.min(
        Math.max(
          value,
          minimum
        ),
        maximum
      );

    }



    function smoothstep(
      value
    ) {

      const x =
        clamp(
          value,
          0,
          1
        );


      return (
        x *
        x *
        (
          3 -
          2 *
          x
        )
      );

    }



    function lerp(
      start,
      end,
      progress
    ) {

      return (
        start +
        (
          end -
          start
        ) *
        progress
      );

    }



    function shouldRunEdgeEffect() {

      if (
        !edgeEffectEnabled
      ) {
        return false;
      }


      if (
        window.innerWidth <=
        749
      ) {

        return mobileEdgeEffectEnabled;

      }


      return true;

    }



    /* =====================================================
       LOOP WIDTH
    ===================================================== */

    function getLoopWidth() {

      return firstGroup
        .getBoundingClientRect()
        .width;

    }



    /* =====================================================
       NORMALIZE TRACK
    ===================================================== */

    function normalizePosition() {

      const loopWidth =
        getLoopWidth();


      if (
        !loopWidth
      ) {
        return;
      }


      while (
        position <=
        -loopWidth
      ) {

        position +=
          loopWidth;

      }


      while (
        position >=
        0
      ) {

        position -=
          loopWidth;

      }

    }



    /* =====================================================
       TRACK TRANSFORM
    ===================================================== */

    function applyTrackTransform() {

      track.style.transform =
        `translate3d(${position}px, 0, 0)`;

    }



    /* =====================================================
       RESET CARDS
    ===================================================== */

    function resetCards() {

      slots.forEach(
        (slot) => {

          const card =
            slot.querySelector(
              '[data-editorial-card]'
            );


          if (
            !card
          ) {
            return;
          }


          card.style.setProperty(
            '--edge-card-scale',
            '1'
          );


          card.dataset.edgeSide =
            'center';


          card.style.zIndex =
            '5';

        }
      );

    }



    /* =====================================================
       EDGE STRETCH EFFECT
    ===================================================== */

    function updateEdgeCards() {


      if (
        !shouldRunEdgeEffect()
      ) {

        resetCards();

        return;

      }



      const viewportRect =
        viewport
          .getBoundingClientRect();


      const viewportLeft =
        viewportRect.left;


      const viewportRight =
        viewportRect.right;



      slots.forEach(
        (slot) => {


          const card =
            slot.querySelector(
              '[data-editorial-card]'
            );


          if (
            !card
          ) {
            return;
          }



          /*
            IMPORTANT:
            Measure fixed slot, not transformed card.
          */

          const rect =
            slot
              .getBoundingClientRect();



          /* =================================================
             RIGHT PROGRESS

             0 = card is at right edge
             1 = card is fully clear of right edge zone
          ================================================= */

          const rightRaw =
            (
              viewportRight -
              rect.left
            ) /
            edgeZone;


          const rightProgress =
            clamp(
              rightRaw,
              0,
              1
            );



          /* =================================================
             LEFT PROGRESS

             0 = card is at left edge
             1 = card is fully clear of left edge zone
          ================================================= */

          const leftRaw =
            (
              rect.right -
              viewportLeft
            ) /
            edgeZone;


          const leftProgress =
            clamp(
              leftRaw,
              0,
              1
            );



          /*
            Card is full width only when it has cleared
            BOTH edge zones.
          */

          const rawProgress =
            Math.min(
              rightProgress,
              leftProgress
            );


          const progress =
            smoothstep(
              rawProgress
            );


          const scale =
            lerp(
              minimumScale,
              1,
              progress
            );



          /* =================================================
             TRANSFORM ORIGIN SIDE
          ================================================= */

          let side =
            'center';


          if (
            rightProgress <
            leftProgress
          ) {

            side =
              'right';

          } else if (
            leftProgress <
            rightProgress
          ) {

            side =
              'left';

          }



          const zIndex =
            rawProgress <
            1
              ? 20
              : 10;



          card.style.setProperty(
            '--edge-card-scale',
            scale.toFixed(4)
          );


          card.dataset.edgeSide =
            side;


          card.style.zIndex =
            String(
              zIndex
            );

        }
      );

    }



    /* =====================================================
       ANIMATION
    ===================================================== */

    function animate(
      timestamp
    ) {


      if (
        lastTimestamp ===
        null
      ) {

        lastTimestamp =
          timestamp;

      }



      const elapsed =
        Math.min(
          50,
          timestamp -
          lastTimestamp
        );


      lastTimestamp =
        timestamp;



      if (
        autoplayEnabled &&
        !temporarilyPaused
      ) {


        position +=
          direction *
          speed *
          (
            elapsed /
            1000
          );


        normalizePosition();


        applyTrackTransform();

      }



      updateEdgeCards();



      animationFrame =
        window.requestAnimationFrame(
          animate
        );

    }



    /* =====================================================
       AUTOPLAY UI
    ===================================================== */

    function updateAutoplayButton() {


      if (
        !autoplayButton
      ) {
        return;
      }


      autoplayButton.setAttribute(
        'aria-label',

        autoplayEnabled
          ? 'Pause carousel'
          : 'Play carousel'
      );


      autoplayButton.setAttribute(
        'aria-pressed',

        autoplayEnabled
          ? 'true'
          : 'false'
      );


      if (
        playIcon
      ) {

        playIcon.hidden =
          autoplayEnabled;

      }


      if (
        pauseIcon
      ) {

        pauseIcon.hidden =
          !autoplayEnabled;

      }


      if (
        autoplayText
      ) {

        autoplayText.textContent =
          autoplayEnabled
            ? 'Pause'
            : 'Play';

      }

    }



    /* =====================================================
       MOVE ONE CARD
    ===================================================== */

    function moveByCard(
      multiplier
    ) {


      const slot =
        slots[0];


      if (
        !slot
      ) {
        return;
      }



      const groupStyles =
        window.getComputedStyle(
          firstGroup
        );


      const gap =
        parseFloat(
          groupStyles.gap ||
          groupStyles.columnGap
        ) ||
        0;



      const distance =
        slot
          .getBoundingClientRect()
          .width +
        gap;



      position +=
        distance *
        multiplier;


      normalizePosition();



      track.style.transition =
        'transform 500ms cubic-bezier(0.22, 1, 0.36, 1)';


      applyTrackTransform();



      window.setTimeout(
        () => {

          track.style.transition =
            '';

          lastTimestamp =
            null;

        },
        520
      );

    }



    /* =====================================================
       AUTOPLAY BUTTON
    ===================================================== */

    autoplayButton
      ?.addEventListener(
        'click',
        () => {


          autoplayEnabled =
            !autoplayEnabled;


          lastTimestamp =
            null;


          updateAutoplayButton();

        }
      );



    /* =====================================================
       ARROWS
    ===================================================== */

    previousButton
      ?.addEventListener(
        'click',
        () => {

          moveByCard(
            1
          );

        }
      );


    nextButton
      ?.addEventListener(
        'click',
        () => {

          moveByCard(
            -1
          );

        }
      );



    /* =====================================================
       PAUSE ON HOVER
    ===================================================== */

    if (
      pauseOnHover
    ) {


      viewport.addEventListener(
        'mouseenter',
        () => {

          temporarilyPaused =
            true;

        }
      );


      viewport.addEventListener(
        'mouseleave',
        () => {

          temporarilyPaused =
            false;

          lastTimestamp =
            null;

        }
      );

    }



    /* =====================================================
       CUSTOM CURSOR
    ===================================================== */

    if (
      customCursor &&
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches
    ) {


      cardLinks.forEach(
        (link) => {


          link.addEventListener(
            'pointerenter',
            (event) => {


              customCursor
                .classList
                .add(
                  'is-visible'
                );


              customCursor.style.left =
                `${event.clientX}px`;


              customCursor.style.top =
                `${event.clientY}px`;

            }
          );



          link.addEventListener(
            'pointermove',
            (event) => {


              customCursor.style.left =
                `${event.clientX}px`;


              customCursor.style.top =
                `${event.clientY}px`;

            }
          );



          link.addEventListener(
            'pointerleave',
            () => {


              customCursor
                .classList
                .remove(
                  'is-visible'
                );

            }
          );

        }
      );

    }



    /* =====================================================
       PAGE VISIBILITY
    ===================================================== */

    const visibilityHandler =
      () => {


        temporarilyPaused =
          document.hidden;


        lastTimestamp =
          null;

      };


    document.addEventListener(
      'visibilitychange',
      visibilityHandler
    );



    /* =====================================================
       RESIZE
    ===================================================== */

    const resizeHandler =
      () => {


        normalizePosition();


        applyTrackTransform();


        updateEdgeCards();

      };


    window.addEventListener(
      'resize',
      resizeHandler,
      {
        passive:
          true
      }
    );



    /* =====================================================
       INITIAL POSITION
    ===================================================== */

    const loopWidth =
      getLoopWidth();


    if (
      direction ===
        1 &&
      loopWidth
    ) {

      position =
        -loopWidth;

    }


    applyTrackTransform();


    updateEdgeCards();


    updateAutoplayButton();



    animationFrame =
      window.requestAnimationFrame(
        animate
      );



    /* =====================================================
       DESTROY
    ===================================================== */

    section._editorialDestroy =
      () => {


        if (
          animationFrame
        ) {

          window.cancelAnimationFrame(
            animationFrame
          );

        }


        document.removeEventListener(
          'visibilitychange',
          visibilityHandler
        );


        window.removeEventListener(
          'resize',
          resizeHandler
        );


        section.dataset.initialized =
          'false';

      };

  }



  /* =========================================================
     INITIALIZE ALL SECTIONS ON PAGE
  ========================================================= */

  function initializeAllEditorialMarquees(
    root = document
  ) {


    const sections =
      root.querySelectorAll(
        '[data-editorial-section]'
      );


    sections.forEach(
      initializeEditorialMarquee
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initializeAllEditorialMarquees();

      }
    );

  } else {

    initializeAllEditorialMarquees();

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {


      const section =
        event.target.querySelector(
          '[data-editorial-section]'
        );


      if (
        section
      ) {

        section.dataset.initialized =
          'false';


        initializeEditorialMarquee(
          section
        );

      }

    }
  );



  document.addEventListener(
    'shopify:section:unload',
    (event) => {


      const section =
        event.target.querySelector(
          '[data-editorial-section]'
        );


      if (
        section &&
        typeof section._editorialDestroy ===
          'function'
      ) {

        section._editorialDestroy();

      }

    }
  );

})();